import { TabsProps } from 'antd'
import { RouterPages } from 'shared/model/routes'

export const analyticsTabs: TabsProps['items'] = [
  {
    label: 'Метрики гостя',
    key: RouterPages.guestMetrics,
  },
  {
    label: 'Финансовые метрики',
    key: RouterPages.financialMetrics,
  },
  {
    label: 'Метрики меню',
    key: RouterPages.menuMetrics,
  },
  {
    label: 'Программа лояльности',
    key: RouterPages.loyaltyPrograms,
  },
  {
    label: 'ЖЦК',
    key: RouterPages.gck,
  },
  {
    label: 'Доставка',
    key: RouterPages.delivery,
  },
  {
    label: 'Филиал',
    key: RouterPages.branch,
  },
  {
    label: 'Меню',
    key: RouterPages.menu,
  },
  {
    label: 'Взаимодействие с приложением',
    key: RouterPages.appInteraction,
  },
  {
    label: 'Удовлетворенность',
    key: RouterPages.satisfaction,
  },
]
